import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface AlertDescriptionProps {
  text: string;
}

export const AlertDescription: React.FC<AlertDescriptionProps> = ({ text }) => {
  const [styles] = useStyles();

  return (
    <View style={styles.descriptionContainer}>
      <Text style={[TYPOGRAPHY.medium, styles.text]}>{text}</Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  descriptionContainer: {
    backgroundColor: theme.colors.background,
    borderRadius: 8,
    flexDirection: 'column',
    padding: 16,
  },
  text: { lineHeight: 24 },
}));
